export const misReportsMenuDef = [
  {
    "name": "menu.ot_cathlab_reports",
    "resource": "ot_cathlab_reports",
    "icon": "fa fa-plus-square",
    "url": "ot_cathlab_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    name: 'menu.update_discharge_form',
    resource: 'update_discharge_form',
    icon: 'fa fa-superpowers',
    url: 'update_discharge_form',
    auto_crud: true,
    breadcrumb: 'Update Discharge Form',
    showMenu: false
  },
  {
    name: 'menu.mis_patient_summary_count',
    resource: 'mis_patient_summary_count',
    icon: 'fa fa-plus-square',
    url: 'mis_patient_summary_count',
    auto_crud: true,
    breadcrumb: 'Update Discharge Form',
    showMenu: false
  },
  {
    "name": "diet_order_summary",
    "resource": "diet_order_summary",
    "url": "diet_order_summary",
    "auto_crud": true
  },
  {
    "name": "menu.registration_reports",
    "resource": "registration_reports",
    "icon": "fa fa-plus-square",
    "url": "registration_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "resource": "manage_account_users_details",
    "url": "manage_account_users_details",
    "auto_crud": true
  },
  {
    "name": "menu.mis_template_details",
    "resource": "mis_template_details",
    "url": "mis_template_details",
    "auto_crud": true
  },
  {
    "name": "menu.registration_reports",
    "resource": "mis_itemtype_wise_stockout",
    "icon": "fa fa-plus-square",
    "url": "mis_itemtype_wise_stockout",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.pharmacy_reports",
    "resource": "pharmacy_reports",
    "icon": "fa fa-plus-square",
    "url": "pharmacy_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.billing_reports",
    "resource": "billing_reports",
    "icon": "fa fa-plus-square",
    "url": "billing_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.diagnostic_reports",
    "resource": "diagnostic_reports",
    "icon": "fa fa-plus-square",
    "url": "diagnostic_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_surgery_bill_wise_report",
    "resource": "mis_surgery_bill_wise_report",
    "icon": "fa fa-plus-square",
    "url": "mis_surgery_bill_wise_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_user_collection_base",
    "resource": "mis_user_collection_base",
    "icon": "fa fa-plus-square",
    "url": "mis_user_collection_base",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.admission_reports",
    "resource": "admission_reports",
    "icon": "fa fa-plus-square",
    "url": "admission_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.ambulance_reports",
    "resource": "ambulance_reports",
    "icon": "fa fa-plus-square",
    "url": "ambulance_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.appointment_reports",
    "resource": "appointment_reports",
    "icon": "fa fa-plus-square",
    "url": "appointment_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.inventory_reports",
    "resource": "inventory_reports",
    "icon": "fa fa-plus-square",
    "url": "inventory_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_admissionConversionReport",
    "resource": "mis_admissionConversionReport",
    "icon": "fa fa-plus-square",
    "url": "mis_admissionConversionReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_dischargeReport",
    "resource": "mis_dischargeReport",
    "icon": "fa fa-plus-square",
    "url": "mis_dischargeReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_admissionReport",
    "resource": "mis_admissionReport",
    "icon": "fa fa-plus-square",
    "url": "mis_admissionReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_bedoccupancy_details",
    "resource": "mis_bedoccupancy_details",
    "icon": "fa fa-plus-square",
    "url": "mis_bedoccupancy_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_erAdmissionReport",
    "resource": "mis_erAdmissionReport",
    "icon": "fa fa-plus-square",
    "url": "mis_erAdmissionReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_erDischargeReport",
    "resource": "mis_erDischargeReport",
    "icon": "fa fa-plus-square",
    "url": "mis_erDischargeReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_doctorTransferReport",
    "resource": "mis_doctorTransferReport",
    "icon": "fa fa-plus-square",
    "url": "mis_doctorTransferReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ipAdmissionReport",
    "resource": "mis_ipAdmissionReport",
    "icon": "fa fa-plus-square",
    "url": "mis_ipAdmissionReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_registrationReport",
    "resource": "mis_registrationReport",
    "icon": "fa fa-plus-square",
    "url": "mis_registrationReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_registrationReport",
    "resource": "mis_appointment_total_visit_report",
    "icon": "fa fa-plus-square",
    "url": "mis_appointment_total_visit_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ambulanceCompleted",
    "resource": "mis_ambulanceCompleted",
    "icon": "fa fa-plus-square",
    "url": "mis_ambulanceCompleted",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_error_handling",
    "resource": "mis_error_handling",
    "icon": "fa fa-plus-square",
    "url": "mis_error_handling",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_preRegistrationReport",
    "resource": "mis_preRegistrationReport",
    "icon": "fa fa-plus-square",
    "url": "mis_preRegistrationReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  }, {
    "name": "menu.mis_convertRegistrationReport",
    "resource": "mis_convertRegistrationReport",
    "icon": "fa fa-plus-square",
    "url": "mis_convertRegistrationReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ambulanceRequest",
    "resource": "mis_ambulanceRequest",
    "icon": "fa fa-plus-square",
    "url": "mis_ambulanceRequest",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_appointmentReport",
    "resource": "mis_appointmentReport",
    "icon": "fa fa-plus-square",
    "url": "mis_appointmentReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_cancelledIpAdmissionReport",
    "resource": "mis_cancelledIpAdmissionReport",
    "icon": "fa fa-plus-square",
    "url": "mis_cancelledIpAdmissionReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_doctorEventOffScheduleReport",
    "resource": "mis_doctorEventOffScheduleReport",
    "icon": "fa fa-plus-square",
    "url": "mis_doctorEventOffScheduleReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {

    "name": "menu.mis_itemMasterReport",
    "resource": "mis_itemMasterReport",
    "icon": "fa fa-plus-square",
    "url": "mis_itemMasterReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.admission_conversion_report",
    "resource": "mis_erToIpConversionReport",
    "icon": "fa fa-plus-square",
    "url": "mis_erToIpConversionReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_grnDetailReport",
    "resource": "mis_grnDetailReport",
    "icon": "fa fa-plus-square",
    "url": "mis_grnDetailReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_grnSummaryReport",
    "resource": "mis_grnSummaryReport",
    "icon": "fa fa-plus-square",
    "url": "mis_grnSummaryReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_bedStatusReport",
    "resource": "mis_bedStatusReport",
    "icon": "fa fa-plus-square",
    "url": "mis_bedStatusReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_otBookingReport",
    "resource": "mis_otBookingReport",
    "icon": "fa fa-plus-square",
    "url": "mis_otBookingReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_otRescheduledSurgeryReport",
    "resource": "mis_otRescheduledSurgeryReport",
    "icon": "fa fa-plus-square",
    "url": "mis_otRescheduledSurgeryReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_otSurgeryReport",
    "resource": "mis_otSurgeryReport",
    "icon": "fa fa-plus-square",
    "url": "mis_otSurgeryReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_otSurgeryReport_ot_wise",
    "resource": "mis_otSurgeryReport_ot_wise",
    "icon": "fa fa-plus-square",
    "url": "mis_otSurgeryReport_ot_wise",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_otSurgeryReport_format",
    "resource": "mis_otSurgeryReport_format",
    "icon": "fa fa-plus-square",
    "url": "mis_otSurgeryReport_format",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_otUtilizationReport",
    "resource": "mis_otUtilizationReport",
    "icon": "fa fa-plus-square",
    "url": "mis_otUtilizationReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ot_tat",
    "resource": "mis_ot_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_ot_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ipPharmacyReport",
    "resource": "mis_ipPharmacyReport",
    "icon": "fa fa-plus-square",
    "url": "mis_ipPharmacyReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ot_InfectiousSummary_Report",
    "resource": "mis_ot_InfectiousSummary_Report",
    "icon": "fa fa-plus-square",
    "url": "mis_ot_InfectiousSummary_Report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ot_InfectiousDetail_Report",
    "resource": "mis_ot_InfectiousDetail_Report",
    "icon": "fa fa-plus-square",
    "url": "mis_ot_InfectiousDetail_Report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_otPAC_report",
    "resource": "mis_otPAC_report",
    "icon": "fa fa-plus-square",
    "url": "mis_otPAC_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ot_Infectious_format",
    "resource": "mis_ot_Infectious_format",
    "icon": "fa fa-plus-square",
    "url": "mis_ot_Infectious_format",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_opPharmacyReport",
    "resource": "mis_opPharmacyReport",
    "icon": "fa fa-plus-square",
    "url": "mis_opPharmacyReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacyIssueReport",
    "resource": "mis_pharmacyIssueReport",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacyIssueReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_cashDetailUserWiseReport",
    "resource": "mis_cashDetailUserWiseReport",
    "icon": "fa fa-plus-square",
    "url": "mis_cashDetailUserWiseReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pathologyReport",
    "resource": "mis_pathologyReport",
    "icon": "fa fa-plus-square",
    "url": "mis_pathologyReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_neurologyReport",
    "resource": "mis_neurologyReport",
    "icon": "fa fa-plus-square",
    "url": "mis_neurologyReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_cardiologyReport",
    "resource": "mis_cardiologyReport",
    "icon": "fa fa-plus-square",
    "url": "mis_cardiologyReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pulmunologyReport",
    "resource": "mis_pulmunologyReport",
    "icon": "fa fa-plus-square",
    "url": "mis_pulmunologyReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_nuclearMedicineReport",
    "resource": "mis_nuclearMedicineReport",
    "icon": "fa fa-plus-square",
    "url": "mis_nuclearMedicineReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pathologyServiceReport",
    "resource": "mis_pathologyServiceReport",
    "icon": "fa fa-plus-square",
    "url": "mis_pathologyServiceReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.labAnalysisReport",
    "resource": "labAnalysisReport",
    "icon": "fa fa-plus-square",
    "url": "labAnalysisReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_nuclearMedicineServiceReport",
    "resource": "mis_nuclearMedicineServiceReport",
    "icon": "fa fa-plus-square",
    "url": "mis_nuclearMedicineServiceReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_radiologyServiceReport",
    "resource": "mis_radiologyServiceReport",
    "icon": "fa fa-plus-square",
    "url": "mis_radiologyServiceReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_radiologyReport",
    "resource": "mis_radiologyReport",
    "icon": "fa fa-plus-square",
    "url": "mis_radiologyReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_stockReport",
    "resource": "mis_stockReport",
    "icon": "fa fa-plus-square",
    "url": "mis_stockReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_bedTransferReport",
    "resource": "mis_bedTransferReport",
    "icon": "fa fa-plus-square",
    "url": "mis_bedTransferReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_advanceDepositReport",
    "resource": "mis_advanceDepositReport",
    "icon": "fa fa-plus-square",
    "url": "mis_advanceDepositReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ipPatientReport",
    "resource": "mis_ipPatientReport",
    "icon": "fa fa-plus-square",
    "url": "mis_ipPatientReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_sponsorPatientLedgerReport",
    "resource": "mis_sponsorPatientLedgerReport",
    "icon": "fa fa-plus-square",
    "url": "mis_sponsorPatientLedgerReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_neurologyServiceReport",
    "resource": "mis_neurologyServiceReport",
    "icon": "fa fa-plus-square",
    "url": "mis_neurologyServiceReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_cardiologyServiceReport",
    "resource": "mis_cardiologyServiceReport",
    "icon": "fa fa-plus-square",
    "url": "mis_cardiologyServiceReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pulmonologyServiceReport",
    "resource": "mis_pulmonologyServiceReport",
    "icon": "fa fa-plus-square",
    "url": "mis_pulmonologyServiceReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_doctorEventOffSummaryReport",
    "resource": "mis_doctorEventOffSummaryReport",
    "icon": "fa fa-plus-square",
    "url": "mis_doctorEventOffSummaryReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  }, {
    "name": "menu.mis_billing_detail",
    "resource": "mis_billing_detail",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_detail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_opSaleReport",
    "resource": "mis_opSaleReport",
    "icon": "fa fa-plus-square",
    "url": "mis_opSaleReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_opReturnReport",
    "resource": "mis_opReturnReport",
    "icon": "fa fa-plus-square",
    "url": "mis_opReturnReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_purchaseGstIn",
    "resource": "mis_purchaseGstIn",
    "icon": "fa fa-plus-square",
    "url": "mis_purchaseGstIn",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pending_po",
    "resource": "mis_pending_po",
    "icon": "fa fa-plus-square",
    "url": "mis_pending_po",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_low_stock_items",
    "resource": "mis_low_stock_items",
    "icon": "fa fa-plus-square",
    "url": "mis_low_stock_items",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_expired_stock",
    "resource": "mis_expired_stock",
    "icon": "fa fa-plus-square",
    "url": "mis_expired_stock",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pr_detail_report",
    "resource": "mis_pr_detail_report",
    "icon": "fa fa-plus-square",
    "url": "mis_pr_detail_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_item_wise_consumption",
    "resource": "mis_item_wise_consumption",
    "icon": "fa fa-plus-square",
    "url": "mis_item_wise_consumption",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_stock_consolidate",
    "resource": "mis_stock_consolidate",
    "icon": "fa fa-plus-square",
    "url": "mis_stock_consolidate",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_returnGstIn",
    "resource": "mis_returnGstIn",
    "icon": "fa fa-plus-square",
    "url": "mis_returnGstIn",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_refundReport",
    "resource": "mis_refundReport",
    "icon": "fa fa-plus-square",
    "url": "mis_refundReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_discountSummaryReport",
    "resource": "mis_discountSummaryReport",
    "icon": "fa fa-plus-square",
    "url": "mis_discountSummaryReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_billingDetail",
    "resource": "mis_billingDetail",
    "icon": "fa fa-plus-square",
    "url": "mis_billingDetail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_billing_item_detail",
    "resource": "mis_billing_item_detail",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_item_detail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },

  {
    "name": "menu.mis_billing_summary",
    "resource": "mis_billing_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_billing_summary_details",
    "resource": "mis_billing_summary_details",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_summary_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_discountDetail",
    "resource": "mis_discountDetail",
    "icon": "fa fa-plus-square",
    "url": "mis_discountDetail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_doctorPayoutReport",
    "resource": "mis_doctorPayoutReport",
    "icon": "fa fa-plus-square",
    "url": "mis_doctorPayoutReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_doctorPayoutReportV2",
    "resource": "mis_doctorPayoutReportV2",
    "icon": "fa fa-plus-square",
    "url": "mis_doctorPayoutReportV2",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_doctorPayoutReportV3",
    "resource": "mis_doctorPayoutReportV3",
    "icon": "fa fa-plus-square",
    "url": "mis_doctorPayoutReportV3",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_dateWiseCashCollection",
    "resource": "mis_dateWiseCashCollection",
    "icon": "fa fa-plus-square",
    "url": "mis_dateWiseCashCollection",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_diagnostic_tat",
    "resource": "mis_diagnostic_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_diagnostic_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pathology_tat",
    "resource": "mis_pathology_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_pathology_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pathology_service",
    "resource": "mis_pathology_service",
    "icon": "fa fa-plus-square",
    "url": "mis_pathology_service",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_histopathology_tat",
    "resource": "mis_histopathology_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_histopathology_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_histopathology_service",
    "resource": "mis_histopathology_service",
    "icon": "fa fa-plus-square",
    "url": "mis_histopathology_service",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_radiology_service",
    "resource": "mis_radiology_service",
    "icon": "fa fa-plus-square",
    "url": "mis_radiology_service",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_cardiology_service",
    "resource": "mis_cardiology_service",
    "icon": "fa fa-plus-square",
    "url": "mis_cardiology_service",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pulmonology_service",
    "resource": "mis_pulmonology_service",
    "icon": "fa fa-plus-square",
    "url": "mis_pulmonology_service",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_neurology_service",
    "resource": "mis_neurology_service",
    "icon": "fa fa-plus-square",
    "url": "mis_neurology_service",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_nuclearmedicine_service",
    "resource": "mis_nuclearmedicine_service",
    "icon": "fa fa-plus-square",
    "url": "mis_nuclearmedicine_service",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_radiology_tat",
    "resource": "mis_radiology_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_radiology_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_cardiology_tat",
    "resource": "mis_cardiology_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_cardiology_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pulmonology_tat",
    "resource": "mis_pulmonology_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_pulmonology_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_neurology_tat",
    "resource": "mis_neurology_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_neurology_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_nuclearmedicine_tat",
    "resource": "mis_nuclearmedicine_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_nuclearmedicine_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacy_summary",
    "resource": "mis_pharmacy_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacyIpReturnReport",
    "resource": "mis_pharmacyIpReturnReport",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacyIpReturnReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_dueSettlement_format",
    "resource": "mis_dueSettlement_format",
    "icon": "fa fa-plus-square",
    "url": "mis_dueSettlement_format",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_due_settled",
    "resource": "mis_due_settled",
    "icon": "fa fa-plus-square",
    "url": "mis_due_settled",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_due_settled_op",
    "resource": "mis_due_settled_op",
    "icon": "fa fa-plus-square",
    "url": "mis_due_settled_op",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_refund_format",
    "resource": "mis_refund_format",
    "icon": "fa fa-plus-square",
    "url": "mis_refund_format",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_refund_report",
    "resource": "mis_refund_report",
    "icon": "fa fa-plus-square",
    "url": "mis_refund_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_refund_op",
    "resource": "mis_refund_op",
    "icon": "fa fa-plus-square",
    "url": "mis_refund_op",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_refund",
    "resource": "mis_refund",
    "icon": "fa fa-plus-square",
    "url": "mis_refund",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacy_dueSettlement",
    "resource": "mis_pharmacy_dueSettlement",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_dueSettlement",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_grnReturnSummary",
    "resource": "mis_grnReturnSummary",
    "icon": "fa fa-plus-square",
    "url": "mis_grnReturnSummary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_due_settled_er",
    "resource": "mis_due_settled_er",
    "icon": "fa fa-plus-square",
    "url": "mis_due_settled_er",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_refund_er",
    "resource": "mis_refund_er",
    "icon": "fa fa-plus-square",
    "url": "mis_refund_er",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_paymentMode_breakup",
    "resource": "mis_paymentMode_breakup",
    "icon": "fa fa-plus-square",
    "url": "mis_paymentMode_breakup",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ambulance",
    "resource": "mis_ambulance",
    "icon": "fa fa-plus-square",
    "url": "mis_ambulance",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ipPackageReport",
    "resource": "mis_ipPackageReport",
    "icon": "fa fa-plus-square",
    "url": "mis_ipPackageReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_healthCheckup_count",
    "resource": "mis_healthCheckup_count",
    "icon": "fa fa-plus-square",
    "url": "mis_healthCheckup_count",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_departmentWise_revenue",
    "resource": "mis_departmentWise_revenue",
    "icon": "fa fa-plus-square",
    "url": "mis_departmentWise_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.revenue_reports",
    "resource": "revenue_reports",
    "icon": "fa fa-plus-square",
    "url": "revenue_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_payerType_revenue",
    "resource": "mis_payerType_revenue",
    "icon": "fa fa-plus-square",
    "url": "mis_payerType_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_serviceType_revenue",
    "resource": "mis_serviceType_revenue",
    "icon": "fa fa-plus-square",
    "url": "mis_serviceType_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_payerName_revenue",
    "resource": "mis_payerName_revenue",
    "icon": "fa fa-plus-square",
    "url": "mis_payerName_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_billingCategory_revenue",
    "resource": "mis_billingCategory_revenue",
    "icon": "fa fa-plus-square",
    "url": "mis_billingCategory_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ward_revenue",
    "resource": "mis_ward_revenue",
    "icon": "fa fa-plus-square",
    "url": "mis_ward_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_stockAdjustmentReport",
    "resource": "mis_stockAdjustmentReport",
    "icon": "fa fa-plus-square",
    "url": "mis_stockAdjustmentReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.view_stock_aggregate",
    "resource": "view_stock_aggregate",
    "icon": "fa fa-plus-square",
    "url": "view_stock_aggregate",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_healthCount_summary",
    "resource": "mis_healthCount_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_healthCount_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_payerExpiry",
    "resource": "mis_payerExpiry",
    "icon": "fa fa-plus-square",
    "url": "mis_payerExpiry",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_expiredPatient",
    "resource": "mis_expiredPatient",
    "icon": "fa fa-plus-square",
    "url": "mis_expiredPatient",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_advanceDepositForAdmission",
    "resource": "mis_advanceDepositForAdmission",
    "icon": "fa fa-plus-square",
    "url": "mis_advanceDepositForAdmission",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_storeToStoreItemIssue",
    "resource": "mis_storeToStoreItemIssue",
    "icon": "fa fa-plus-square",
    "url": "mis_storeToStoreItemIssue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_opSaleWithTags",
    "resource": "mis_opSaleWithTags",
    "icon": "fa fa-plus-square",
    "url": "mis_opSaleWithTags",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ipIssueWithTags",
    "resource": "mis_ipIssueWithTags",
    "icon": "fa fa-plus-square",
    "url": "mis_ipIssueWithTags",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_itemStock_dailyInflowOutflow",
    "resource": "mis_itemStock_dailyInflowOutflow",
    "icon": "fa fa-plus-square",
    "url": "mis_itemStock_dailyInflowOutflow",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.stockConsumptionReport",
    "resource": "stockConsumptionReport",
    "icon": "fa fa-plus-square",
    "url": "stockConsumptionReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.open_indent",
    "resource": "open_indent",
    "icon": "fa fa-plus-square",
    "url": "open_indent",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_stock_daily_inOutFlow_new",
    "resource": "mis_stock_daily_inOutFlow",
    "icon": "fa fa-plus-square",
    "url": "mis_stock_daily_inOutFlow",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_tax_summary",
    "resource": "mis_tax_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_tax_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_tax_detail",
    "resource": "mis_tax_detail",
    "icon": "fa fa-plus-square",
    "url": "mis_tax_detail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_councelling_summary",
    "resource": "mis_councelling_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_councelling_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_councelling_package_summary",
    "resource": "mis_councelling_package_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_councelling_package_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_councelling_detail",
    "resource": "mis_councelling_detail",
    "icon": "fa fa-plus-square",
    "url": "mis_councelling_detail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_dailyTransactions",
    "resource": "mis_dailyTransactions",
    "icon": "fa fa-plus-square",
    "url": "mis_dailyTransactions",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_dailyItemStock",
    "resource": "mis_dailyItemStock",
    "icon": "fa fa-plus-square",
    "url": "mis_dailyItemStock",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.oltp_to_mis",
    "resource": "oltp_to_mis",
    "icon": "fa fa-plus-square",
    "url": "oltp_to_mis",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.update_transaction_data",
    "resource": "update_transaction_data",
    "icon": "fa fa-plus-square",
    "url": "update_transaction_data",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacy_summary_details",
    "resource": "mis_pharmacy_summary_details",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_summary_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacy_item_detail",
    "resource": "mis_pharmacy_item_detail",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_item_detail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.optical_reports",
    "resource": "optical_reports",
    "icon": "fa fa-plus-square",
    "url": "optical_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_pharmacy_ip_item_detail",
    "resource": "mis_pharmacy_ip_item_detail",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_ip_item_detail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pending_bills",
    "resource": "mis_pending_bills",
    "icon": "fa fa-plus-square",
    "url": "mis_pending_bills",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_billing_payment_summary",
    "resource": "mis_billing_payment_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_payment_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_billing_payment_serviceType_summary",
    "resource": "mis_billing_payment_serviceType_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_payment_serviceType_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_billing_serviceType_summary",
    "resource": "mis_billing_serviceType_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_serviceType_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_pharmacy_ip_daily_detail",
    "resource": "mis_pharmacy_ip_daily_detail",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_ip_daily_detail",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacy_and_ward_consumption",
    "resource": "mis_pharmacy_and_ward_consumption",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_and_ward_consumption",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacy_hsn_summary",
    "resource": "mis_pharmacy_hsn_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_hsn_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_billing_revenue",
    "resource": "mis_billing_revenue",
    "icon": "fa fa-plus-square",
    "url": "mis_billing_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_cancel_billReport",
    "resource": "mis_cancel_billReport",
    "icon": "fa fa-plus-square",
    "url": "mis_cancel_billReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_daily_summary",
    "resource": "mis_daily_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_daily_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_summary_facility_wise",
    "resource": "mis_summary_facility_wise",
    "icon": "fa fa-plus-square",
    "url": "mis_summary_facility_wise",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_summary_facility_wise",
    "resource": "mis_summary_facility_wise_v2",
    "icon": "fa fa-plus-square",
    "url": "mis_summary_facility_wise_v2",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_pharmacy_doctor_wise_pharmacy_summary_report",
    "resource": "mis_pharmacy_doctor_wise_pharmacy_summary_report",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_doctor_wise_pharmacy_summary_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_pharmacy_doctor_wise_pharmacy_detailed_report",
    "resource": "mis_pharmacy_doctor_wise_pharmacy_detailed_report",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_doctor_wise_pharmacy_detailed_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_pharmacy_ip_pharmacy_pull_off_reports",
    "resource": "mis_pharmacy_ip_pharmacy_pull_off_reports",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_ip_pharmacy_pull_off_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_stock",
    "resource": "mis_stock",
    "icon": "fa fa-plus-square",
    "url": "mis_stock",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_deposit_consumed_details",
    "resource": "mis_deposit_consumed_details",
    "icon": "fa fa-plus-square",
    "url": "mis_deposit_consumed_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.archived_mis_completed_bills",
    "resource": "archived_mis_completed_bills",
    "icon": "fa fa-plus-square",
    "url": "archived_mis_completed_bills",
    "auto_crud": true,
    "check_permission": false,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.archived_mis_ipBillingDashbord",
    "resource": "archived_mis_ipBillingDashbord",
    "icon": "fa fa-plus-square",
    "url": "archived_mis_ipBillingDashbord",
    "auto_crud": true,
    "check_permission": false,
    "showMenu": true,
    "breadcrumb": "",
  },
  {
    "name": "menu.archived_mis_emrIpPatients",
    "resource": "archived_mis_emrIpPatients",
    "icon": "fa fa-plus-square",
    "url": "archived_mis_emrIpPatients",
    "auto_crud": true,
    "check_permission": false,
    "showMenu": true,
    "breadcrumb": "",
  },
  {
    "name": "menu.archived_misDiagnosticPathology",
    "resource": "archived_misDiagnosticPathology",
    "icon": "fa fa-plus-square",
    "url": "archived_misDiagnosticPathology",
    "auto_crud": true,
    "showMenu": true,
    "check_permission": false,
    "breadcrumb": "",
  },
  {
    "name": "menu.archived_misDiagnosticRadiology",
    "resource": "archived_misDiagnosticRadiology",
    "icon": "fa fa-plus-square",
    "url": "archived_misDiagnosticRadiology",
    "auto_crud": true,
    "showMenu": true,
    "check_permission": false,
    "breadcrumb": "",
  },
  {
    "name": "menu.archived_mis_ipBillingDashboardDischargePatients",
    "resource": "archived_mis_ipBillingDashboardDischargePatients",
    "icon": "fa fa-plus-square",
    "url": "archived_mis_ipBillingDashboardDischargePatients",
    "auto_crud": true,
    "showMenu": true,
    "check_permission": false,
    "breadcrumb": "",
  },
  {
    "name": "menu.archived_mis_opBillingRefund",
    "resource": "archived_mis_opBillingRefund",
    "icon": "fa fa-plus-square",
    "url": "archived_mis_opBillingRefund",
    "auto_crud": true,
    "showMenu": true,
    "check_permission": false,
    "breadcrumb": "",
  },
  {
    "name": "menu.mis_post_reversal_report",
    "resource": "mis_post_reversal_report",
    "icon": "fa fa-plus-square",
    "url": "mis_post_reversal_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_diet_rate_report",
    "resource": "mis_diet_rate_report",
    "icon": "fa fa-plus-square",
    "url": "mis_diet_rate_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_ward_wise_mortality_report",
    "resource": "mis_ward_wise_mortality_report",
    "icon": "fa fa-plus-square",
    "url": "mis_ward_wise_mortality_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.bloodbank_reports",
    "resource": "mis_bloodbank_tat",
    "icon": "fa fa-plus-square",
    "url": "mis_bloodbank_tat",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_grnPendingReport",
    "resource": "mis_grnPendingReport",
    "icon": "fa fa-plus-square",
    "url": "mis_grnPendingReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_stockAdjustment",
    "resource": "mis_stockAdjustment",
    "icon": "fa fa-plus-square",
    "url": "mis_stockAdjustment",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_package_consumption_report",
    "resource": "mis_package_consumption_report",
    "icon": "fa fa-plus-square",
    "url": "mis_package_consumption_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.ward_consumption_status",
    "resource": "ward_consumption_status",
    "icon": "fa fa-plus-square",
    "url": "ward_consumption_status",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "mis_diet_bill_summary",
    "resource": "mis_diet_bill_summary",
    "url": "mis_diet_bill_summary",
    "auto_crud": true
  },
  {
    "name": "menu.mortality_reports",
    "resource": "mortality_report",
    "icon": "fa fa-file-text-o",
    "url": "mortality_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_advance_format",
    "resource": "mis_advance_format",
    "icon": "fa fa-file-text-o",
    "url": "mis_advance_format",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_payer_wise_bill_summary",
    "resource": "mis_payer_wise_bill_summary",
    "icon": "fa fa-file-text-o",
    "url": "mis_payer_wise_bill_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_visit_count_report",
    "resource": "mis_visit_count_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_visit_count_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.archived_appointment",
    "resource": "archived_appointment",
    "icon": "fa fa-plus-square",
    "url": "archived_appointment",
    "auto_crud": true,
    "showMenu": true,
    "check_permission": false,
    "breadcrumb": "",

  },
  {
    "name": "menu.mis_birthReport",
    "resource": "mis_birthReport",
    "icon": "fa fa-plus-square",
    "url": "mis_birthReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true,
    "check_permission": false
  },
  {
    "name": "menu.mis_clinical_diagnosis",
    "resource": "mis_clinical_diagnosis",
    "icon": "fa fa-file-text-o",
    "url": "mis_clinical_diagnosis",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_post_ot_mortality_report",
    "resource": "mis_post_ot_mortality_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_post_ot_mortality_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_pharmacy_bill_details_report",
    "resource": "mis_pharmacy_bill_details_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_pharmacy_bill_details_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_pharmacy_bill_summary_report",
    "resource": "mis_pharmacy_bill_summary_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_pharmacy_bill_summary_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_clinical_vitals_report",
    "resource": "mis_clinical_vitals_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_clinical_vitals_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.store_to_store_item_issue",
    "resource": "store_to_store_mis_layout",
    "icon": "fa fa-plus-square",
    "url": "store_to_store_mis_layout",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_open_return_indent_layout",
    "resource": "mis_open_return_indent_layout",
    "icon": "fa fa-plus-square",
    "url": "mis_open_return_indent_layout",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.cultureAnalysisReport",
    "resource": "cultureAnalysisReport",
    "icon": "fa fa-plus-square",
    "url": "cultureAnalysisReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_average_los_report",
    "resource": "mis_average_los_report",
    "icon": "fa fa-plus-square",
    "url": "mis_average_los_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_anc_count_report",
    "resource": "mis_anc_count_report",
    "icon": "fa fa-plus-square",
    "url": "mis_anc_count_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_appointment_tat_summary",
    "resource": "mis_appointment_tat_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_appointment_tat_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_bed_census_summary",
    "resource": "mis_bed_census_summary",
    "icon": "fa fa-plus-square",
    "url": "mis_bed_census_summary",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_ward_wise_status",
    "resource": "mis_ward_wise_status",
    "url": "mis_ward_wise_status",
    "auto_crud": true
  },
  {
    "name": "menu.mis_clinical_prescription",
    "resource": "mis_clinical_prescription",
    "icon": "fa fa-file-text-o",
    "url": "mis_clinical_prescription",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_service_type_and_item_wise_count_report",
    "resource": "mis_service_type_and_item_wise_count_report",
    "icon": "fa fa-plus-square",
    "url": "mis_service_type_and_item_wise_count_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.covid_compliance_report",
    "resource": "covid_compliance_report",
    "icon": "fa fa-plus-square",
    "url": "covid_compliance_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_immunization_vaccination_report",
    "resource": "mis_immunization_vaccination_report",
    "icon": "fa fa-plus-square",
    "url": "mis_immunization_vaccination_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "resource": "mis_rbac_report_format",
    "url": "mis_rbac_report_format",
    "name": "menu.mis_rbac_report_format",
    "icon": "fa fa-plus-square",
    "breadcrumb": "",
    "auto_crud": true
  },
  {
    "name": "menu.service_type_revenue",
    "resource": "service_type_revenue",
    "icon": "fa fa-plus-square",
    "url": "service_type_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.service_item_wise_count_and_revenue_report",
    "resource": "service_item_wise_count_and_revenue_report",
    "icon": "fa fa-plus-square",
    "url": "service_item_wise_count_and_revenue_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.revenue_tab",
    "resource": "revenue_tab",
    "icon": "fa fa-plus-square",
    "url": "revenue_tab",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_time_wise_mortality_report",
    "resource": "mis_time_wise_mortality_report",
    "icon": "fa fa-plus-square",
    "url": "mis_time_wise_mortality_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_admission_conversion_report",
    "resource": "mis_admission_conversion_report",
    "icon": "fa fa-plus-square",
    "url": "mis_admission_conversion_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_registration_reports",
    "resource": "mis_registration_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_registration_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_surgery_reports",
    "resource": "mis_surgery_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_surgery_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_billing_reports",
    "resource": "mis_billing_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_billing_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_revenue_reports",
    "resource": "mis_revenue_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_revenue_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_advance_and_consume_reports",
    "resource": "mis_advance_and_consume_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_advance_and_consume_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_cancelled_and_unsettled_reports",
    "resource": "mis_cancelled_and_unsettled_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_cancelled_and_unsettled_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.in_patient_item_wise_detail_report",
    "resource": "in_patient_item_wise_detail_report",
    "icon": "fa fa-file-text-o",
    "url": "in_patient_item_wise_detail_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": false
  },
  {
    "name": "menu.unbilled_item_report",
    "resource": "unbilled_item_report",
    "icon": "fa fa-file-text-o",
    "url": "unbilled_item_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": false
  },
  {
    "name": "menu.mis_diet_billing_reports",
    "resource": "mis_diet_billing_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diet_billing_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_discount_refund_and_due_reports",
    "resource": "mis_discount_refund_due_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_discount_refund_due_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_package_and_surgery_reports",
    "resource": "mis_package_and_surgery_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_package_and_surgery_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_payer_mou_expired_reports",
    "resource": "mis_payer_mou_expired_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_payer_mou_expired_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_billing_footfall_reports",
    "resource": "mis_billing_footfall_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_billing_footfall_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_pharmacy_ip_issue_reports",
    "resource": "mis_pharmacy_ip_issue_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_pharmacy_ip_issue_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_pharmacy_op_sale_reports",
    "resource": "mis_pharmacy_op_sale_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_pharmacy_op_sale_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_pharmacy_tat_reports",
    "resource": "mis_pharmacy_tat_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_pharmacy_tat_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_inventory_grn_reports",
    "resource": "mis_inventory_grn_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_inventory_grn_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.issue_and_consumption_reports",
    "resource": "mis_issue_and_consumption_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_issue_and_consumption_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_virtual_store_indent_report",
    "resource": "mis_virtual_store_indent_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_virtual_store_indent_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_virtual_store_indentReturn_report",
    "resource": "mis_virtual_store_indentReturn_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_virtual_store_indentReturn_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_inventory_ledger_reports",
    "resource": "mis_inventory_ledger_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_inventory_ledger_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_inventory_item_reports",
    "resource": "mis_inventory_item_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_inventory_item_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_inventory_pr_po_reports",
    "resource": "mis_inventory_pr_po_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_inventory_pr_po_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_appointment_reports",
    "resource": "mis_appointment_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_appointment_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_appointment_tat_reports",
    "resource": "mis_appointment_tat_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_appointment_tat_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_clinical_infection_reports",
    "resource": "mis_clinical_infection_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_clinical_infection_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_clinical_reports",
    "resource": "mis_clinical_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_clinical_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_pathology_reports",
    "resource": "mis_diagnostic_pathology_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_pathology_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_histopathology_reports",
    "resource": "mis_diagnostic_histopathology_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_histopathology_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_cardiology_reports",
    "resource": "mis_diagnostic_cardiology_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_cardiology_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_radiology_reports",
    "resource": "mis_diagnostic_radiology_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_radiology_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_pulmonology_reports",
    "resource": "mis_diagnostic_pulmonology_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_pulmonology_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_nuclear_medicine_reports",
    "resource": "mis_diagnostic_nuclear_medicine_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_nuclear_medicine_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_neurology_reports",
    "resource": "mis_diagnostic_neurology_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_neurology_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_diagnostic_blood_bank_reports",
    "resource": "mis_diagnostic_blood_bank_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_diagnostic_blood_bank_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_expired_patients_age_wise",
    "resource": "mis_expired_patients_age_wise",
    "icon": "fa fa-file-text-o",
    "url": "mis_expired_patients_age_wise",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_admissions_bed_reports",
    "resource": "mis_admissions_bed_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_admissions_bed_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_admission_discharge_and_transfer_reports",
    "resource": "mis_admission_discharge_and_transfer_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_admission_discharge_and_transfer_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_sponsor_patient_management",
    "resource": "mis_sponsor_patient_management",
    "icon": "fa fa-file-text-o",
    "url": "mis_sponsor_patient_management",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_ambulance_reports",
    "resource": "mis_ambulance_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_ambulance_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_opticals_reports",
    "resource": "mis_opticals_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_opticals_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_death_detail_report",
    "resource": "mis_death_detail_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_death_detail_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    name: 'menu.oltp_to_mis_v1',
    icon: 'fa fa-tag',
    resource: 'oltp_to_mis_v1',
    url: 'oltp_to_mis_v1',
    auto_crud: true
  },
  {
    "name": "menu.mis_grnPendingReport",
    "resource": "mis_challanReport",
    "icon": "fa fa-plus-square",
    "url": "mis_challanReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_grnPendingReport",
    "resource": "mis_challanReturnReport",
    "icon": "fa fa-plus-square",
    "url": "mis_challanReturnReport",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_counselling_reports",
    "resource": "mis_counselling_reports",
    "icon": "fa fa-plus-square",
    "url": "mis_counselling_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_doctor_wise_footfall",
    "resource": "mis_doctor_wise_footfall",
    "icon": "fa fa-plus-square",
    "url": "mis_doctor_wise_footfall",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_visit_count_doctor_wise_report",
    "resource": "mis_visit_count_doctor_wise_report",
    "icon": "fa fa-plus-square",
    "url": "mis_visit_count_doctor_wise_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_visit_count_doctor_wise_report",
    "resource": "mis_template_assessment",
    "icon": "fa fa-plus-square",
    "url": "mis_template_assessment",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_item_consumption_detail_report",
    "resource": "mis_item_consumption_detail_report",
    "icon": "fa fa-plus-square",
    "url": "mis_item_consumption_detail_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_custom_gst_print",
    "resource": "mis_custom_gst_print",
    "icon": "fa fa-plus-square",
    "url": "mis_custom_gst_print",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_referral_request_report",
    "resource": "mis_referral_request_report",
    "icon": "fa fa-plus-square",
    "url": "mis_referral_request_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.encounter_history_bed_details",
    "resource": "encounter_history_bed_details",
    "icon": "fa fa-plus-square",
    "url": "encounter_history_bed_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.encounter_history_ward_details",
    "resource": "encounter_history_ward_details",
    "icon": "fa fa-plus-square",
    "url": "encounter_history_ward_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.encounter_history_doctor_details",
    "resource": "encounter_history_doctor_details",
    "icon": "fa fa-plus-square",
    "url": "encounter_history_doctor_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_common_diagnostic_report",
    "resource": "mis_common_diagnostic_report",
    "icon": "fa fa-plus-square",
    "url": "mis_common_diagnostic_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.patient_wise_payer_changes_report",
    "resource": "patient_wise_payer_changes_report",
    "icon": "fa fa-plus-square",
    "url": "patient_wise_payer_changes_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_discount_summary_report_v1",
    "resource": "mis_discount_summary_report_v1",
    "icon": "fa fa-plus-square",
    "url": "mis_discount_summary_report_v1",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_package_summary_report",
    "resource": "mis_package_summary_report",
    "icon": "fa fa-plus-square",
    "url": "mis_package_summary_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_inter_facility_referral_request_report",
    "resource": "mis_inter_facility_referral_request_report",
    "icon": "fa fa-plus-square",
    "url": "mis_inter_facility_referral_request_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.discharge_summary_mis",
    "resource": "discharge_summary_mis",
    "url": "discharge_summary_mis",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "menu.account_level_optical_advance_advance",
    "resource": "account_level_optical_advance_advance",
    "icon": "fa fa-plus-square",
    "url": "account_level_optical_advance_advance",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_doctor_wise_opd_count_report",
    "resource": "mis_doctor_wise_opd_count_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_doctor_wise_opd_count_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_doctor_wise_count_reports",
    "resource": "mis_doctor_wise_count_reports",
    "icon": "fa fa-file-text-o",
    "url": "mis_doctor_wise_count_reports",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.admissionPivotReport",
    "resource": "admissionPivotReport",
    "icon": "fa fa-file-text-o",
    "url": "admissionPivotReport",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.dischargePivotReport",
    "resource": "dischargePivotReport",
    "icon": "fa fa-file-text-o",
    "url": "dischargePivotReport",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_admission_type_wise_revenue",
    "resource": "mis_admission_type_wise_revenue",
    "icon": "fa fa-file-text-o",
    "url": "mis_admission_type_wise_revenue",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.admission_asondate_report",
    "resource": "admission_asondate_report",
    "icon": "fa fa-file-text-o",
    "url": "admission_asondate_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_discount_detail_report",
    "resource": "mis_discount_detail_report",
    "icon": "fa fa-file-text-o",
    "url": "mis_discount_detail_report",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.new_cancelled_previous_bills_mis",
    "resource": "new_cancelled_previous_bills_mis",
    "icon": "fa fa-file-text-o",
    "url": "new_cancelled_previous_bills_mis",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.new_cancelled_previous_billing_item_mis",
    "resource": "new_cancelled_previous_billing_item_mis",
    "icon": "fa fa-file-text-o",
    "url": "new_cancelled_previous_billing_item_mis",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.new_cancelled_previous_bill_register_mis",
    "resource": "new_cancelled_previous_bill_register_mis",
    "icon": "fa fa-file-text-o",
    "url": "new_cancelled_previous_bill_register_mis",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.SAP_int",
    "resource": "failed_bills_tabs",
    "icon": "fa fa-user",
    "url": "failed_bills_tabs",
    "auto_crud": true,
    "check_permission": false
  },
  {
    "name": "menu.mis_referral_request",
    "resource": "mis_referral_request",
    "icon": "fa fa-user",
    "url": "mis_referral_request",
    "auto_crud": true,
    "check_permission": false
  },
  {
    "name": "menu.mis_care_plan_reports_format",
    "resource": "mis_care_plan_reports_format",
    "icon": "fa fa-file-text-o",
    "url": "mis_care_plan_reports_format",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
  {
    "name": "menu.mis_care_plan_upgrade_report",
    "resource": "mis_care_plan_upgrade_report",
    "icon": "fa fa-plus-square",
    "url": "mis_care_plan_upgrade_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_care_plan_report",
    "resource": "mis_care_plan_report",
    "icon": "fa fa-plus-square",
    "url": "mis_care_plan_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.mis_pharmacy_user_wise_count",
    "resource": "mis_pharmacy_user_wise_count",
    "icon": "fa fa-plus-square",
    "url": "mis_pharmacy_user_wise_count",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.bloodbank_reports",
    "resource": "mis_bb_issued_report",
    "icon": "fa fa-plus-square",
    "url": "mis_bb_issued_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true,
  },
  {
    "name": "menu.mis_bb_order_detail_report",
    "resource": "mis_bb_order_detail_report",
    "icon": "fa fa-plus-square",
    "url": "mis_bb_order_detail_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_bb_blood_component_report",
    "resource": "mis_bb_component_summary_report",
    "icon": "fa fa-plus-square",
    "url": "mis_bb_blood_component_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.billing_item_wise_detail_surgery_breakup_report",
    "resource": "billing_item_wise_detail_surgery_breakup_report",
    "icon": "fa fa-plus-square",
    "url": "billing_item_wise_detail_surgery_breakup_report",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": true
  },
  {
    "name": "menu.mis_treating_doctor_speciality_count",
    "resource": "mis_treating_doctor_speciality_count",
    "icon": "fa fa-file-text-o",
    "url": "mis_treating_doctor_speciality_count",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },
 {
    "name": "menu.mis_clinical_nursing_format",
    "resource": "mis_clinical_nursing_format",
    "icon": "fa fa-file-text-o",
    "url": "mis_clinical_nursing_format",
    "auto_crud": true,
    "breadcrumb": "",
    "check_permission": true
  },

]